import { enStatus } from 'interface/course';
import { IShowcaseCourse } from 'interface/showcase';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SvgIcon } from 'components/Shared/SvgIcon';
import LockIcon from '@eduzz/houston-icons/LockedSolid';
import ClockLock from '@eduzz/houston-icons/TimerOutline';
import { useRef } from 'react';

interface IProps {
  course: IShowcaseCourse;
  isNewCourse: boolean;
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 3,
    '& .houston-icon': {
      transform: 'translateY(-20%) scale(4)',
      '@media(max-width: 1440px)': {
        transform: 'translateY(-20%) scale(2.5)',
      },
    },
    '& svg': {
      fill: theme.palette.common.white,
    },
  },
}));

const BackdropStatus = (props: IProps) => {
  const classes = useStyles();
  const { current: iconStatusMapper } = useRef({
    [enStatus.EXPIRED]: <ClockLock />,
    [enStatus.BLOCKED]: <LockIcon />,
    [enStatus.NOT_RELEASED]: <LockIcon />,
    new: <SvgIcon name='bell' />,
  });
  const { current: colorStatusMapper } = useRef({
    [enStatus.EXPIRED]: 'rgba(255, 202, 40, 0.4)',
    [enStatus.BLOCKED]: 'rgba(244, 67, 54, 0.4)',
    [enStatus.NOT_RELEASED]: 'rgba(255,255,255, 0.4)',
    new: 'rgba(0, 200, 83, 0.4)',
  });

  const status = props.isNewCourse ? 'new' : props.course.status;
  const statusColor = colorStatusMapper[status];

  return (
    <div className={classes.backdrop} style={statusColor && { background: statusColor }}>
      {iconStatusMapper[status]}
    </div>
  );
};

export default BackdropStatus;
